import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { FormattedDate } from 'react-intl';
import AnswersList from '../AnswersList.jsx';
import ProductList from '../ProductList.jsx';
import HealthScoreBarChart from '../charts/HealthScoreBarChart';
import { healthScoreKeys } from '../../utils/healthScoreHelper';
import {
  useNeuroMessages,
  useAnswers,
  useProducts,
  useGuideConfig,
  useDispatch,
  flatProductList,
  NeuroMessage,
  useUser,
  ContactFormModal,
  sendToLeadProcessor
} from "@ignitesales/neuro-application";
import cognitoConfig from '../../utils/cognitoConfig.js';
import saveKafkaStatus from '../../../../../../regionsBranchTheme/src/shared/js/utils/saveKafkaStatus.js';

const DetailsPage = ({ classname, actionCompleted }) => {
  const messageContext = useNeuroMessages();
  const dispatch = useDispatch();
  const { uuid } = useUser();
  const { answers } = useAnswers();
  const { products } = useProducts();
  const { guideId } = useGuideConfig();
  const productList = flatProductList(products);
  const pageCssBEM = 'detailsPage';
  const classes = classnames(pageCssBEM, classname);
  const financialHealthScore = answers?.financialHealthScore?.value;
  const recDate = <FormattedDate value={Date.now()} year="numeric" month="long" day="2-digit" />;
  const [ showContactModal, setContactModalView ] = useState(false);
  const [ appointmentHasBeenScheduled, setAppointmentHasBeenScheduled ] = useState(answers?.appointmentId?.value.length > 0);
  const leadProcessorCommand = { command: 'GenericRest', uuid, guideId };

  useEffect(() => {
    saveKafkaStatus('kafka_lead_success', 'DetailsPage', 'use effect', 'Init summary page');

    const executeLeadProcessor = async () => {
      try {
        const response = await sendToLeadProcessor(cognitoConfig(), leadProcessorCommand);
        const data = await response(dispatch)
        const result = data?.isSuccess ? data.isSuccess : data;
        saveKafkaStatus('kafka_lead_success','DetailsPage','executeLeadProcessor', result);
      } catch (error) {
        saveKafkaStatus('kafka_lead_error','DetailsPage','executeLeadProcessor', error.message);
      }
    };

    executeLeadProcessor();
  }, []);

  const graphScore = () => {
    return financialHealthScore > 0 ?
    <div className={`${pageCssBEM}__graphScore`}>
      {`Your financial health score is ${Math.round(financialHealthScore)}`}
    </div> : null;
  };

  const graphLegend = () => {
    return financialHealthScore > 0 ?
    <div className={`${pageCssBEM}__graphLegend`}>
      <span>0</span>
      <span>25</span>
      <span>50</span>
      <span>75</span>
      <span>100</span>
    </div> : null;
  };

  const graphFooter = () => {
    let text = '';
    if (financialHealthScore <= 40) {
      text = messageContext.getMessage('finScoreGraphLow');
    } else if (financialHealthScore > 40 && financialHealthScore <= 80) {
      text = messageContext.getMessage('finScoreGraphMed');
    } else if (financialHealthScore > 80) {
      text = messageContext.getMessage('finScoreGraphHigh');
    }

    return text?.length > 0 ? <div className={`${pageCssBEM}__graphFooter`}>{ text }</div> : null;
  };

  return (
    <div className={ classes }>
      {/* { financialHealthScore &&
        <div className={ `${ pageCssBEM }__healthScore` }>
          <NeuroMessage id="details.financialScore" tagName="h2" />
          <HealthScoreBarChart data={healthScoreKeys} delay={0} financialHealthScore={financialHealthScore} isPrintPage={true} />
          { graphScore() }
          { graphLegend() }
          { graphFooter() }
        </div>
       } */}
      <div className={ `${ pageCssBEM }__products` }>
        <NeuroMessage id="details.recommendations" tagName="h2" />
        <ProductList products={ productList } isCollapsibleListOpen={ true } onShowContactModal={() => setContactModalView(true)} appointmentScheduled={appointmentHasBeenScheduled} />
      </div>

      <div className={ `${ pageCssBEM }__recommendation` }>
        <NeuroMessage id="summary.recommendationId" values={{uuid:
          uuid, date: recDate}} tagName="p" />
       </div>

      <AnswersList answers={ answers } actionCompleted={ actionCompleted } isCollapsibleListOpen={ true } />

      <ContactFormModal
        className='contactMe'
        isOpen={ showContactModal }
        onClose={ () => setContactModalView(false) }
        useAppointmentFlow={true}
        onComplete={ () => setAppointmentHasBeenScheduled(true) }
        closeBtn={'x'}
        backButton={'Back'}
      />
    </div>
  );
};

export default DetailsPage;
